import { RiInformationFill } from 'react-icons/ri';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { convertDateToTimeStamp, formatAmount, getToken } from '../utils';
import { LoadingMode } from '../Components/LoadingMode';
import { toast } from 'react-toastify';
import CustomMessage from '../Components/CustomMessage';

export const FormFields = () => {
  // const [isplacingOffer, setIsplacingOffer] = useState(false);
  const [lvRate, setLvRate] = useState({});

  const [isShowingCurrencyInfo, setIsShowingCurrencyInfo] = useState(false);
  const [isShowingCurrencyInfos, setIsShowingCurrencyInfos] = useState(false);
  const [isShowingAccountLocationInfo, setIsShowingAccountLocationInfo] =
    useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [localData, setLocalData] = useState([]);
  const [foreignData, setForeignData] = useState([]);

  const [, setIsLoadingRate] = useState(false);
  const [allData, setAllData] = useState({});
  const [isOpen, setIsOpen] = useState(false); // State to manage dropdown visibility
  const [selectedOptions, setSelectedOptions] = useState([]); // State to store selected options
  
  const [inputs, setInputs] = useState({
    transaction_type_id: '',
    base_currency_id: '',
    quote_currency_id: '',
    transaction_method_id: '',
    receipient_type_id: '',
    amount: '',
    total_amount: '',
    account_id: '',
    rate_type_id: '',
    system_rate: false,
    custom_rate: '',
    deadline: '',
    remark: '',
    country_id: '',
    user_type_id: '',
  });

    // Function to toggle dropdown visibility
    const toggleDropdown = () => {
      setIsOpen(!isOpen);
    };
  
     // Function to handle selection of options
  const handleOptionClick = (value) => {
    let updatedOptions;
    if (selectedOptions.includes(value)) {
      updatedOptions = selectedOptions.filter((option) => option !== value);
    } else {
      updatedOptions = [...selectedOptions, value];
    }
    setSelectedOptions(updatedOptions);
    // Convert array to comma-separated string
  const updatedOptionsString = updatedOptions.join(',');
    setInputs((input) => ({
      ...input,
      country_id: updatedOptionsString,
    }));
  };

  const [step, setStep] = useState(1);
    // const [passwordStrengthText, setPasswordStrengthText] = useState('');
    // const [togglePassword, setTogglePassword] = useState(false);
    // const [image, setImage] = useState('');

    // const handleFileChange = (event) => {
    //     const file = event.target.files[0];
    //     const reader = new FileReader();
    //     reader.onload = (e) => setImage(e.target.result);
    //     reader.readAsDataURL(file);
    // };

    // const checkPasswordStrength = () => {
    //     // Implement your password strength check logic here
    //     // Update setPasswordStrengthText accordingly
    // };

  const navigate = useNavigate();

  const { token: userToken } = getToken();

  const systemIdbe = allData?.rate_types?.find((data) => {
    return data.name === 'Lv Rate';
  })?.id;

  const customIdbe = allData?.rate_types?.find((data) => {
    return data.name === 'Custom Rate';
  })?.id;

  const transationType = allData?.transaction_types?.find((data) => {
    return data?.id === Number(inputs.transaction_type_id);
  })?.name;

  const formData = {
    transaction_type_id: inputs.transaction_type_id,
    base_currency_id: inputs.base_currency_id,
    quote_currency_id: inputs.quote_currency_id,
    transaction_method_id: inputs.transaction_method_id,
    receipient_type_id: inputs.receipient_type_id,
    amount: inputs.amount,
    account_id: inputs.account_id,
    rate_type_id: inputs.system_rate ? systemIdbe : customIdbe,
    rate: inputs.system_rate ? lvRate?.sellLVRate?.price : inputs.custom_rate,
    deadline: convertDateToTimeStamp(inputs.deadline),
    remark: inputs.remark,
    country_id: inputs.country_id,
    user_type_id: inputs.user_type_id,
  };

  const handleChange = (e) => {
    const target = e.target;
    const { value, name, type, checked, options } = target;
  
    if (name === 'country_id') {
      // Handle multiple select for country_id
      let selectedValues = [];
      for (let i = 0, l = options.length; i < l; i++) {
        if (options[i].selected) {
          selectedValues.push(options[i].value);
        }
      }
      // Join selected values with comma
      const selectedValuesString = selectedValues.join(',');
      setInputs((input) => ({
        ...input,
        [name]: selectedValuesString,
      }));
    } else if (name === 'system_rate') {
      // Handle system_rate checkbox
      setInputs((input) => ({
        ...input,
        [name]: checked,
        custom_rate: checked ? lvRate?.sellLVRate?.price : '0.00',
      }));
    } else {
      // Handle other input fields
      setInputs((input) => ({
        ...input,
        [name]: type === 'checkbox' ? checked : value,
      }));
    }
  };
   

  const handlePlaceOffer = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/cx-transaction/store`,
        formData,
        {
          headers: { Authorization: `Bearer ${userToken}` },
        }
      );

      if (inputs.transaction_type_id === '1') {
        navigate('/tradecurrency/p2p/buy');
      } else {
        navigate('/tradecurrency/p2p/sell');
      }
      toast(<CustomMessage status='placed' />, { autoClose: 2000 });
    } catch (error) {
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCustomRate = useCallback(async () => {
    const data = {
      base_currency_id: inputs.base_currency_id,
      quote_currency_id: inputs.quote_currency_id,
    };

    if (inputs.base_currency_id === '' || inputs.quote_currency_id === '') {
      return;
    }
    setIsLoadingRate(true);
    const url = `${process.env.REACT_APP_BASE_URL}/exchange-rates/get-rate`;
    try {
      const response = await axios.post(url, data, {
        headers: { Authorization: `Bearer ${userToken}` },
      });

      setLvRate({ sellLVRate: response.data });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingRate(false);
    }
  }, [inputs.base_currency_id, inputs.quote_currency_id, userToken]);

  const customRate =
    inputs.base_currency_id !== '' && inputs.quote_currency_id !== '';

  useEffect(() => {
    handleCustomRate();
  }, [customRate, handleCustomRate]);

  useEffect(() => {
    // const controller = new AbortController();

    const fetchData = async () => {
      setIsLoading(true);
      const url = `${process.env.REACT_APP_BASE_URL}/dashboard/all-settings`;
      try {
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${userToken}` },
        });

        setAllData(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
    // fetchSystemRate();
    // postLocalAccount();
  }, [userToken]);

  useEffect(() => {
    const localAccount = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/local-accounts`,
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );
        setLocalData(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    localAccount();
  }, [userToken]);

  useEffect(() => {
    const foriegnAccount = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/cx-accounts`,
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );
        setForeignData(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    foriegnAccount();
  }, [userToken]);

  const allAccounts = [...localData, ...foreignData];
  const totalAmountSymbol = allData?.currencies?.find((data) => {
    return data?.id === Number(inputs.base_currency_id);
  })?.symbol;

  return (
    <section className='w-full'>
      <div className='w-full flex flex-col gap-16 px-6 py-8 drop-shadow-lg bg-p-wh rounded-lg'>
        <div className='flex flex-row gap-2 text-p-bk bg-b-mct px-4 py-4 rounded-lg'>
          <span className='text-xl'>
            <RiInformationFill />
          </span>
          <p className='text-sm'>
            You will be charged 0.1% transaction fee if you are on a FREE plan
            or 0.05% if on a paid plan. To subscribe to the premium plan{' '}
            <span className='text-b-mc'>Click here </span>
          </p>
        </div>

        <form
          className='w-full flex flex-col gap-16'
          onSubmit={handlePlaceOffer}
        >
          <div className='w-full'>
            {/* Step 1 */}
            {step === 1 && (
                <div>
                    <div className='w-full flex gap-8 flex-col'>
              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin relative'>
                  Transaction Type
                </label>
                <select
                  name='transaction_type_id'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.transaction_type_id}
                  onChange={handleChange}
                  required
                >
                  <option value='' className='text-s-bk'>
                    Select ....
                  </option>
                  {allData.transaction_types?.map((data) => (
                    <option key={data?.id} value={data?.id}>
                      {data.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin flex flex-row gap-2 items-center relative'>
                  Currency{' '}
                  <span
                    className='text-md text-p-bk'
                    onMouseEnter={() => setIsShowingCurrencyInfo(true)}
                    onMouseLeave={() => setIsShowingCurrencyInfo(false)}
                  >
                    <RiInformationFill />
                  </span>
                  {isShowingCurrencyInfo &&
                    (transationType === 'Sell' ? (
                      <span className='text-[10px] text-p-wh -top-4 left-[6.5rem] bg-p-bk px-2 absolute py-1 rounded-lg'>
                        Choose the currency you want to sell
                      </span>
                    ) : (
                      <span className='text-[10px] text-p-wh -top-4 left-[6.5rem] bg-p-bk px-2 absolute py-1 rounded-lg'>
                        Choose the currency you want to buy
                      </span>
                    ))}
                </label>

                <select
                  name='quote_currency_id'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.quote_currency_id}
                  onChange={handleChange}
                  required
                >
                  {' '}
                  <option value='' className='text-s-bk'>
                    Select ....
                  </option>
                  {allData.currencies
                    ?.filter(currency => currency.type.id === 2)
                    .map(currency => (
                      <option key={currency.id} value={currency.id}>
                        {currency.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin relative'>
                  Who will receive this request?
                </label>

                <select
                  name='user_type_id'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.user_type_id}
                  onChange={handleChange}
                  required
                >
                  {' '}
                  <option value='' className='text-s-bk'>
                    Select ....
                  </option>
                  {allData.user_types?.map((data) => (
                    <option key={data?.id} value={data?.id}>
                      {data.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin relative'>
                  Payment method
                </label>

                <select
                  name='transaction_method_id'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.transaction_method_id}
                  onChange={handleChange}
                  required
                >
                  {' '}
                  <option value='' className='text-s-bk'>
                    Select ....
                  </option>
                  {allData?.transaction_methods?.map((data) => (
                    <option key={data?.id} value={data?.id}>
                      {data.name}
                    </option>
                  ))}
                </select>
              </div>
              
            </div>
            <div className=' w-full flex flex-col gap-2'>
              <button 
                    className=' py-2.5 px-10 w-fit text-b-mc rounded-lg relative disabled:text-f-bk hover:bg-b-mc/75 hover:text-p-wh focus:bg-b-mc/80 font-semibold disabled:bg-b-mct'

                    onClick={() => setStep(step + 1)}
                    >Next</button>
            </div>
                    
                </div>
            )}

            {/* Step 2 */}
            {step === 2 && (
                <div>
                    <div className='w-full flex gap-8 flex-col'>
              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin flex flex-row gap-2 items-center relative'>
                  {transationType === 'Sell'
                    ? 'Receive Currency'
                    : ' Buy Currency with'}
                  <span
                    className='text-md text-p-bk'
                    onMouseEnter={() => setIsShowingCurrencyInfos(true)}
                    onMouseLeave={() => setIsShowingCurrencyInfos(false)}
                  >
                    <RiInformationFill />
                  </span>
                  {isShowingCurrencyInfos &&
                    (transationType === 'Sell' ? (
                      <span className='text-[10px] text-p-wh -top-4 left-[11.5rem] bg-p-bk px-2 absolute py-1 rounded-lg'>
                        Choose the currency you want to receive
                      </span>
                    ) : (
                      <span className='text-[10px] text-p-wh -top-4 left-[11.5rem] bg-p-bk px-2 absolute py-1 rounded-lg'>
                        Choose the currency you want to exchange
                      </span>
                    ))}
                </label>
                <select
                  name='base_currency_id'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.base_currency_id}
                  onChange={handleChange}
                  required
                >
                  {' '}
                  <option value='' className='text-s-bk'>
                    Select ....
                  </option>
                  {allData.currencies
                    ?.filter(currency => currency.type.id === 1)
                    .map(currency => (
                      <option key={currency.id} value={currency.id}>
                        {currency.name}
                      </option>
                    ))}
                </select>
              </div>
           {/* Country select with checkboxes */}
          <div className='w-full flex flex-col gap-2'>
            <div className='text-p-bk text-base font-pin gap-2 items-center flex flex-row relative'>
              <label>Account Location </label>
              <span
                className='text-md text-p-bk'
                onMouseEnter={() => setIsShowingAccountLocationInfo(true)}
                onMouseLeave={() => setIsShowingAccountLocationInfo(false)}
              >
                <RiInformationFill />
              </span>
              {isShowingAccountLocationInfo && (
                <div className='text-p-wh -top-8 left-[11.5rem] bg-p-bk px-2 absolute py-1 rounded-lg'>
                  <p className='-8 text-[10px]'>Choose bank account location where you</p>{' '}
                  <p className='-mt-2 text-[10px]'>want to receive the money</p>
                </div>
              )}
            </div>

            {/* Custom select with checkboxes */}
            <div className='relative'>
              <div
                className='py-2 px-4 w-full border-t-bk border-[1px] rounded-lg cursor-pointer flex items-center justify-between'
                onClick={toggleDropdown}
              >
                <div className='flex flex-wrap'>
                  {selectedOptions.length === 0 ? (
                    <span className='text-gray-400'>Select ....</span>
                  ) : (
                    selectedOptions.map((option, index) => (
                      <span
                        key={index}
                        className='bg-gray-200 px-2 py-1 rounded-full m-1'
                      >
                        {allData.countrys.find((country) => country.id === option)?.name}
                      </span>
                    ))
                  )}
                </div>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  className={`h-6 w-6 ${isOpen ? 'transform rotate-180' : ''}`}
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                >
                  <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 9l-7 7-7-7' />
                </svg>
              </div>
              {isOpen && (
                <div className='absolute z-10 w-full bg-white border-t-bk border-[1px] rounded-b-lg shadow-lg mt-1'>
                  {allData.countrys.map((data) => (
                    <label
                      key={data.id}
                      className='block px-4 py-2 cursor-pointer hover:bg-gray-100'
                    >
                      <input
                        type='checkbox'
                        className='form-checkbox mr-2 cursor-pointer'
                        value={data.id}
                        checked={selectedOptions.includes(data.id)}
                        onChange={() => handleOptionClick(data.id)}
                      />
                      {data.name}
                    </label>
                  ))}
                </div>
              )}
            </div>
          </div>
              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin relative'>
                  Recipient type
                </label>

                <select
                  name='receipient_type_id'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.receipient_type_id}
                  onChange={handleChange}
                  required
                >
                  <option value='' className='text-s-bk'>
                    Select ....
                  </option>
                  {allData?.account_types?.map((data) => (
                    <option key={data?.id} value={data?.id}>
                      {data.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin relative'>
                  Offer Instruction
                </label>

                <select
                  name='remark'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.remark}
                  onChange={handleChange}
                  required
                >
                  {' '}
                  <option value='' className='text-s-bk'>
                    Select ....
                  </option>
                  {allData.cx_messages?.map((data) => (
                    <option key={data?.id} value={data?.id}>
                      {data.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
                    {/* <button onClick={() => setTogglePassword(!togglePassword)}>Show/Hide Password</button> */}
                    <div className='w-full flex gap-8 flex-row'>
                    <div className=' w-full flex flex-col gap-2'>
                      <button 
                      className=' py-2.5 px-10 w-fit text-b-mc rounded-lg relative disabled:text-f-bk hover:bg-b-mc/75 hover:text-p-wh focus:bg-b-mc/80 font-semibold disabled:bg-b-mct'

                      onClick={() => setStep(step - 1)}
                      >
                        Back
                      </button>
                    </div>
                    <div className=' w-full flex flex-col gap-2'>
                      <button 
                      className=' py-2.5 px-10 w-fit text-b-mc rounded-lg relative disabled:text-f-bk hover:bg-b-mc/75 hover:text-p-wh focus:bg-b-mc/80 font-semibold disabled:bg-b-mct'

                      onClick={() => setStep(step + 1)}
                      >Next</button>
                    </div>
                      
                      
                    </div>
                    
                </div>
            )}

            {/* Step 3 */}
            {step === 3 && (
                <div>
                  <div className='w-full flex gap-8 flex-col'>
              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin relative'>
                  Amount{' '}
                  <span className='text-xs'>(FX you want to buy/sell)</span>
                </label>

                <input
                  type='number'
                  name='amount'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.amount}
                  onChange={handleChange}
                  placeholder='0.00'
                  required
                />
              </div>
              <div className='w-full flex flex-row gap-6'>
                <div className='flex flex-col items-left gap-5 w-1/2'>
                  <label className='text-p-bk text-base font-pin relative'>
                    Use system rate
                  </label>
                  <input
                    type='checkbox'
                    id='hs-medium-switch'
                    name='system_rate'
                    className='relative shrink-0 w-[3.25rem] h-7 bg-gray-100 checked:bg-none checked:bg-blue-400 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 ring-1 ring-transparent focus:border-blue-400 focus:ring-blue-400 ring-offset-white focus:outline-none appearance-none dark:bg-s-bk dark:checked:bg-b-mc dark:focus:ring-offset-gray-800 before:inline-block before:w-6 before:h-6 before:bg-white checked:before:bg-blue-200 before:translate-x-0 checked:before:translate-x-full before:shadow before:rounded-full before:transform before:ring-0 before:transition before:ease-in-out before:duration-200 dark:before:bg-p-wh dark:checked:before:bg-blue-200'
                    checked={inputs.system_rate}
                    onChange={handleChange}
                    onClick={handleCustomRate}
                  />
                </div>
                <div className=' max-w-[218px] flex flex-col gap-2'>
                  <label className='text-p-bk text-base font-pin relative'>
                    Custom rate
                  </label>

                  <input
                    type='number'
                    name='custom_rate'
                    className='py-2 focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg disabled:bg-f-bk disabled:text-s-bk'
                    disabled={inputs.system_rate === true}
                    value={
                      inputs.system_rate
                        ? formatAmount(lvRate?.sellLVRate?.price)
                        : inputs.custom_rate
                    }
                    onChange={handleChange}
                    placeholder={
                      inputs.system_rate
                        ? formatAmount(lvRate?.sellLVRate?.price)
                        : '0.00'
                    }
                    required
                  />
                </div>
              </div>
              <div className='w-full flex flex-row gap-6'>
                <div className=' w-1/2 flex flex-col gap-2'>
                  <label className='text-p-bk text-base font-pin relative'>
                    Transaction Deadline
                  </label>

                  <input
                    type='date'
                    name='deadline'
                    className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                    value={inputs.deadline}
                    onChange={handleChange}
                    placeholder='message'
                    required
                  />
                </div>
                <div className='w-1/2 flex flex-col gap-2'>
                  <label className='text-p-bk text-base font-pin relative'>
                    Total Amount
                  </label>
                  <div className='py-2 focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'>
                    {!!inputs.amount
                      ? !!inputs.system_rate
                        ? `${
                            !!lvRate?.sellLVRate?.price
                              ? formatAmount(
                                  inputs.amount * lvRate?.sellLVRate?.price
                                )
                              : '0.00'
                          } ${!!totalAmountSymbol ? totalAmountSymbol : ''}`
                        : `${formatAmount(
                            inputs.amount * inputs.custom_rate
                          )} ${!!totalAmountSymbol ? totalAmountSymbol : ''}`
                      : '0.00'}
                  </div>
                </div>
              </div>

              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin relative'>
                  Bank Account
                </label>
                <select
                  name='account_id'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.account_id}
                  onChange={handleChange}
                  required
                >
                  <option value='' className='text-s-bk'>
                    Select ....
                  </option>
                  {Number(inputs.transaction_type_id) === 1
                    ? allAccounts
                        ?.filter((data) => {
                          return (
                            data?.currency?.id ===
                            Number(inputs?.quote_currency_id)
                          );
                        })
                        .map((data, index) => {
                          return (
                            <option key={index} value={data?.id}>
                              {data?.bank_name}, {data?.currency?.name} (
                              {data?.currency?.symbol}), {data?.country?.name}
                            </option>
                          );
                        })
                    : allAccounts
                        ?.filter((data) => {
                          return (
                            data?.currency?.id ===
                            Number(inputs?.base_currency_id)
                          );
                        })
                        .map((data, index) => {
                          return (
                            <option key={index} value={data?.id}>
                              {data?.bank_name}, {data?.currency?.name} (
                              {data?.currency?.symbol}), {data?.country?.name}
                            </option>
                          );
                        })}
                </select>
                {!allAccounts.length && (
                  <button
                    className='bg-b-mc py-2 px-4 w-fit text-p-wh rounded-lg relative disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 font-semibold disabled:bg-b-mct text-sm'
                    onClick={() => navigate('/paymentmethod')}
                  >
                    Add Bank Account
                  </button>
                )}
              </div>
                  </div>
                  {/* <button
            type='submit'
            className='bg-b-mc py-2.5 px-10 w-fit text-p-wh rounded-lg relative disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 font-semibold disabled:bg-b-mct'
            disabled={isSubmitting}
          >
            Place Offer
            {isSubmitting && <LoadingMode />}
          </button> */}
          <div className=' w-full flex flex-row gap-6'>
            <div className=' w-full flex flex-col gap-2'>
            <button
                    className=' py-2.5 px-10 w-fit text-b-mc rounded-lg relative disabled:text-f-bk hover:bg-b-mc/75 hover:text-p-wh focus:bg-b-mc/80 font-semibold disabled:bg-b-mct'
                     onClick={() => setStep(step - 1)}>Back</button>
          </div>
          <div className=' w-full flex flex-col gap-2'>
            <button
                    type='submit'
                    className=' py-2.5 px-10 w-fit text-b-mc rounded-lg relative disabled:text-f-bk hover:bg-b-mc/75 hover:text-p-wh focus:bg-b-mc/80 font-semibold disabled:bg-b-mct'
                    disabled={isSubmitting}
                    //  onClick={() => setStep(step + 1)}
                     >Place Offer
                     {isSubmitting && <LoadingMode />}
                     </button>
          </div>
          </div>
          
                    
                    
                </div>
            )}
          </div>
            
        </form>

        {/* <form
          className='w-full flex flex-col gap-16'
          onSubmit={handlePlaceOffer}
        >
          <div className='w-full flex flex-col md:flex-row gap-6'>
            <div className='w-full flex gap-8 flex-col'>
              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin relative'>
                  Transaction Type
                </label>
                <select
                  name='transaction_type_id'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.transaction_type_id}
                  onChange={handleChange}
                  required
                >
                  <option value='' className='text-s-bk'>
                    Select ....
                  </option>
                  {allData.transaction_types?.map((data) => (
                    <option key={data?.id} value={data?.id}>
                      {data.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin flex flex-row gap-2 items-center relative'>
                  Currency{' '}
                  <span
                    className='text-md text-p-bk'
                    onMouseEnter={() => setIsShowingCurrencyInfo(true)}
                    onMouseLeave={() => setIsShowingCurrencyInfo(false)}
                  >
                    <RiInformationFill />
                  </span>
                  {isShowingCurrencyInfo &&
                    (transationType === 'Sell' ? (
                      <span className='text-[10px] text-p-wh -top-4 left-[6.5rem] bg-p-bk px-2 absolute py-1 rounded-lg'>
                        Choose the currency you want to sell
                      </span>
                    ) : (
                      <span className='text-[10px] text-p-wh -top-4 left-[6.5rem] bg-p-bk px-2 absolute py-1 rounded-lg'>
                        Choose the currency you want to buy
                      </span>
                    ))}
                </label>

                <select
                  name='quote_currency_id'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.quote_currency_id}
                  onChange={handleChange}
                  required
                >
                  {' '}
                  <option value='' className='text-s-bk'>
                    Select ....
                  </option>
                  {allData.currencies?.map((currency) => (
                    // `${currency.id}` !== inputs.base_currency_id &&
                    <option key={currency?.id} value={currency?.id}>
                      {currency.name} {currency.symbol}
                    </option>
                  ))}
                </select>
              </div>
              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin relative'>
                  Amount{' '}
                  <span className='text-xs'>(FX you want to buy/sell)</span>
                </label>

                <input
                  type='number'
                  name='amount'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.amount}
                  onChange={handleChange}
                  placeholder='0.00'
                  required
                />
              </div>
              <div className='w-full flex flex-row gap-6'>
                <div className='flex flex-col items-left gap-5 w-1/2'>
                  <label className='text-p-bk text-base font-pin relative'>
                    Use system rate
                  </label>
                  <input
                    type='checkbox'
                    id='hs-medium-switch'
                    name='system_rate'
                    className='relative shrink-0 w-[3.25rem] h-7 bg-gray-100 checked:bg-none checked:bg-blue-400 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 ring-1 ring-transparent focus:border-blue-400 focus:ring-blue-400 ring-offset-white focus:outline-none appearance-none dark:bg-s-bk dark:checked:bg-b-mc dark:focus:ring-offset-gray-800 before:inline-block before:w-6 before:h-6 before:bg-white checked:before:bg-blue-200 before:translate-x-0 checked:before:translate-x-full before:shadow before:rounded-full before:transform before:ring-0 before:transition before:ease-in-out before:duration-200 dark:before:bg-p-wh dark:checked:before:bg-blue-200'
                    checked={inputs.system_rate}
                    onChange={handleChange}
                    onClick={handleCustomRate}
                  />
                </div>
                <div className=' max-w-[218px] flex flex-col gap-2'>
                  <label className='text-p-bk text-base font-pin relative'>
                    Custom rate
                  </label>

                  <input
                    type='number'
                    name='custom_rate'
                    className='py-2 focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg disabled:bg-f-bk disabled:text-s-bk'
                    disabled={inputs.system_rate === true}
                    value={
                      inputs.system_rate
                        ? formatAmount(lvRate?.sellLVRate?.price)
                        : inputs.custom_rate
                    }
                    onChange={handleChange}
                    placeholder={
                      inputs.system_rate
                        ? formatAmount(lvRate?.sellLVRate?.price)
                        : '0.00'
                    }
                    required
                  />
                </div>
              </div>
              <div className='w-full flex flex-row gap-6'>
                <div className=' w-1/2 flex flex-col gap-2'>
                  <label className='text-p-bk text-base font-pin relative'>
                    Transaction Deadline
                  </label>

                  <input
                    type='date'
                    name='deadline'
                    className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                    value={inputs.deadline}
                    onChange={handleChange}
                    placeholder='message'
                    required
                  />
                </div>
                <div className='w-1/2 flex flex-col gap-2'>
                  <label className='text-p-bk text-base font-pin relative'>
                    Total Amount
                  </label>
                  <div className='py-2 focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'>
                    {!!inputs.amount
                      ? !!inputs.system_rate
                        ? `${
                            !!lvRate?.sellLVRate?.price
                              ? formatAmount(
                                  inputs.amount * lvRate?.sellLVRate?.price
                                )
                              : '0.00'
                          } ${!!totalAmountSymbol ? totalAmountSymbol : ''}`
                        : `${formatAmount(
                            inputs.amount * inputs.custom_rate
                          )} ${!!totalAmountSymbol ? totalAmountSymbol : ''}`
                      : '0.00'}
                  </div>
                </div>
              </div>

              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin relative'>
                  Bank Account
                </label>
                <select
                  name='account_id'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.account_id}
                  onChange={handleChange}
                  required
                >
                  <option value='' className='text-s-bk'>
                    Select ....
                  </option>
                  {Number(inputs.transaction_type_id) === 1
                    ? allAccounts
                        ?.filter((data) => {
                          return (
                            data?.currency?.id ===
                            Number(inputs?.quote_currency_id)
                          );
                        })
                        .map((data, index) => {
                          return (
                            <option key={index} value={data?.id}>
                              {data?.bank_name}, {data?.currency?.name} (
                              {data?.currency?.symbol}), {data?.country?.name}
                            </option>
                          );
                        })
                    : allAccounts
                        ?.filter((data) => {
                          return (
                            data?.currency?.id ===
                            Number(inputs?.base_currency_id)
                          );
                        })
                        .map((data, index) => {
                          return (
                            <option key={index} value={data?.id}>
                              {data?.bank_name}, {data?.currency?.name} (
                              {data?.currency?.symbol}), {data?.country?.name}
                            </option>
                          );
                        })}
                </select>
                {!allAccounts.length && (
                  <button
                    className='bg-b-mc py-2 px-4 w-fit text-p-wh rounded-lg relative disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 font-semibold disabled:bg-b-mct text-sm'
                    onClick={() => navigate('/paymentmethod')}
                  >
                    Add Bank Account
                  </button>
                )}
              </div>
            </div>
            <div className='w-full flex gap-8 flex-col'>
              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin relative'>
                  Who will receive this request?
                </label>

                <select
                  name='user_type_id'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.user_type_id}
                  onChange={handleChange}
                  required
                >
                  {' '}
                  <option value='' className='text-s-bk'>
                    Select ....
                  </option>
                  {allData.user_types?.map((data) => (
                    <option key={data?.id} value={data?.id}>
                      {data.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin relative'>
                  Payment method
                </label>

                <select
                  name='transaction_method_id'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.transaction_method_id}
                  onChange={handleChange}
                  required
                >
                  {' '}
                  <option value='' className='text-s-bk'>
                    Select ....
                  </option>
                  {allData?.transaction_methods?.map((data) => (
                    <option key={data?.id} value={data?.id}>
                      {data.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin flex flex-row gap-2 items-center relative'>
                  {transationType === 'Sell'
                    ? 'Receive Currency'
                    : ' Buy Currency with'}
                  <span
                    className='text-md text-p-bk'
                    onMouseEnter={() => setIsShowingCurrencyInfos(true)}
                    onMouseLeave={() => setIsShowingCurrencyInfos(false)}
                  >
                    <RiInformationFill />
                  </span>
                  {isShowingCurrencyInfos &&
                    (transationType === 'Sell' ? (
                      <span className='text-[10px] text-p-wh -top-4 left-[11.5rem] bg-p-bk px-2 absolute py-1 rounded-lg'>
                        Choose the currency you want to receive
                      </span>
                    ) : (
                      <span className='text-[10px] text-p-wh -top-4 left-[11.5rem] bg-p-bk px-2 absolute py-1 rounded-lg'>
                        Choose the currency you want to exchange
                      </span>
                    ))}
                </label>
                <select
                  name='base_currency_id'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.base_currency_id}
                  onChange={handleChange}
                  required
                >
                  {' '}
                  <option value='' className='text-s-bk'>
                    Select ....
                  </option>
                  {allData.currencies
                    ?.filter(
                      (currency) =>
                        `${currency.id}` !== inputs.quote_currency_id
                    )
                    .map((currency) => (
                      <option key={currency.id} value={currency.id}>
                        {currency.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className=' w-full flex flex-col gap-2'>
                <div className='text-p-bk text-base font-pin gap-2 items-center flex flex-row relative'>
                  <label>Account Location </label>
                  <span
                    className='text-md text-p-bk'
                    onMouseEnter={() => setIsShowingAccountLocationInfo(true)}
                    onMouseLeave={() => setIsShowingAccountLocationInfo(false)}
                  >
                    <RiInformationFill />
                  </span>
                  {isShowingAccountLocationInfo && (
                    <div className=' text-p-wh -top-8 left-[11.5rem] bg-p-bk px-2 absolute py-1 rounded-lg'>
                      <p className='-8 text-[10px]'>
                        Choose bank account location where you
                      </p>{' '}
                      <p className='-mt-2 text-[10px]'>
                        want to receive the money
                      </p>
                    </div>
                  )}
                </div>

                <select
                  name='country_id'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.country_id}
                  onChange={handleChange}
                  required
                >
                  {' '}
                  <option value='' className='text-s-bk'>
                    Select ....
                  </option>
                  {allData.countrys?.map((data) => (
                    <option key={data?.id} value={data?.id}>
                      {data.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin relative'>
                  Recipient type
                </label>

                <select
                  name='receipient_type_id'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.receipient_type_id}
                  onChange={handleChange}
                  required
                >
                  <option value='' className='text-s-bk'>
                    Select ....
                  </option>
                  {allData?.account_types?.map((data) => (
                    <option key={data?.id} value={data?.id}>
                      {data.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className=' w-full flex flex-col gap-2'>
                <label className='text-p-bk text-base font-pin relative'>
                  Offer Instruction
                </label>

                <select
                  name='remark'
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={inputs.remark}
                  onChange={handleChange}
                  required
                >
                  {' '}
                  <option value='' className='text-s-bk'>
                    Select ....
                  </option>
                  {allData.cx_messages?.map((data) => (
                    <option key={data?.id} value={data?.id}>
                      {data.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <button
            type='submit'
            className='bg-b-mc py-2.5 px-10 w-fit text-p-wh rounded-lg relative disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 font-semibold disabled:bg-b-mct'
            disabled={isSubmitting}
          >
            Place Offer
            {isSubmitting && <LoadingMode />}
          </button>
        </form> */}
      </div>
    </section>
  );
};
